import { Carousel, SimpleSlide } from 'src/components/Carousel';
import { IntroSection } from 'src/components/Layout/IntroSection';
import Cta from 'src/components/cta';
import FeatureSectionUsecases from 'src/components/features/feature-section-usecases';
import PageHeader from 'src/components/headers/page-header';
import SocialProof from 'src/components/social-proof';
import { UseCaseTemplate } from 'src/templates';

import { Locales } from 'src/lib/constants';

import {
  ctaData,
  featureSectionData,
  introSectionData,
  metaData,
  pageHeaderData,
  simpleCarouselData,
  socialProofData,
} from 'src/store/en-eu/use-cases/banking-and-wealth';

const EUUseCasesBankingWealth = ({ locale = Locales.EN_EU }) => {
  return (
    <UseCaseTemplate fields={metaData} locale={locale}>
      <PageHeader {...pageHeaderData} />
      <SocialProof {...socialProofData} />
      <IntroSection {...introSectionData} />
      <FeatureSectionUsecases {...featureSectionData} />
      <Carousel>
        {simpleCarouselData['carousel-slides'].map((slide) => {
          return (
            <SimpleSlide
              carouselTitle={simpleCarouselData['carousel-title']}
              {...slide}
            />
          );
        })}
      </Carousel>
      <Cta {...ctaData} />
    </UseCaseTemplate>
  );
};

export default EUUseCasesBankingWealth;
